import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Header from './header';
import Nav from './nav';

const APP_BAR_MOBILE = 48;
const APP_BAR_DESKTOP = 48;
const BANNER_HEIGHT = 48;
const SHOW_BANNER = false;

const StyledRoot = styled('div')({
	display: 'flex',
	height: '100dvh',
	overflow: 'hidden',
	backgroundColor: '#EFF6FF',
});

const Main = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'auto',
	position: 'absolute',
	top: APP_BAR_MOBILE + (SHOW_BANNER ? BANNER_HEIGHT : 0),
	left: 0,
	right: 0,
	bottom: 0,
	paddingTop: theme.spacing(SHOW_BANNER ? 3 : 1),
	paddingLeft: theme.spacing(2),
	paddingBottom: 36,
	[theme.breakpoints.up('sm')]: {
		top: APP_BAR_DESKTOP + (SHOW_BANNER ? BANNER_HEIGHT : 0),
		left: 80, // NAV_COLLAPSED_WIDTH
	},
	[theme.breakpoints.up('md')]: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	},
	[theme.breakpoints.up('lg')]: {
		top: APP_BAR_DESKTOP + (SHOW_BANNER ? BANNER_HEIGHT : 0),
		left: 260, // NAV_WIDTH
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	},
}));

export default function DashboardLayout() {
	const [open, setOpen] = useState<boolean>(false);

	const handleOpenNav = () => setOpen(true);
	const handleCloseNav = () => setOpen(false);

	return (
		<StyledRoot>
			<Header onOpenNav={handleOpenNav} showBanner={SHOW_BANNER} />

			<Nav openNav={open} onCloseNav={handleCloseNav} />

			<Main>
				<Outlet />
			</Main>
		</StyledRoot>
	);
}
